import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Circular from 'material-ui/CircularProgress';

const style = {
    position: 'absolute',
    top: 0,
    right: 0,
    margin: 16,
    zIndex: 1200,
};

class CircularProgress extends Component {

    render() {
        const { isLoading } = this.props;
        return (
            isLoading && <Circular
                className="app-loader"
                color="#fff"
                size={30}
                thickness={2}
                style={style}
            />
        )
    }
}

CircularProgress.propTypes = {
    isLoading: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
    return {
        isLoading: state.admin.loading > 0,
    };
}

export default connect(mapStateToProps)(CircularProgress);



// WEBPACK FOOTER //
// ./src/components/layout/CircularProgress.js